<div class = "button-toggle-item" [class.full-width]="fullWidth" [formGroup]="parent">
  <label for="{{control}}" [class.error]="inputHasErrors() || errorMessage">{{ label }} <span *ngIf="required" class="required">*</span></label>
  <mat-button-toggle-group id="{{control}}" [required]="required"  [formControlName]="control">
    <mat-button-toggle *ngFor="let option of options" value="{{option.value}}">{{option.label}}</mat-button-toggle>
  </mat-button-toggle-group>
</div>
